import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import useContent from 'store/content'
import { getUserInput } from 'libs/localApi'
import { saveUserInput } from 'libs/localApi'

const validate = (inputValidation, inputValue, userInputs) => {
  let error = false

  Object.entries(inputValidation).forEach(([name, value]) => {
    switch (name) {
      case 'required':
        if (!inputValue || inputValue === '') {
          error = true
        }
        break
      case 'min':
        if (parseInt(inputValue) < value) {
          error = true
        }
        break
      case 'max':
        if (parseInt(inputValue) > value) {
          error = true
        }
        break
      case 'number':
        if (parseInt(inputValue) === 'NaN') {
          error = true
        }
        break
      case 'airCanadaRule':
        if (userInputs.lounge === 'alatableyyzd' && parseInt(inputValue) > 100) {
          error = true
        }
        if (userInputs.lounge === 'alatableyyzd' && parseInt(inputValue) < 1) {
          error = true
        }
        break
      default:
        return null
    }
  })

  return error
}

const InputText = ({ input, type = 'text' }) => {
  const content = useContent()
  const appId = content.get.appId()
  const userInputs = getUserInput(appId)
  const storedValue = userInputs && userInputs[input.name]

  const [error, setError] = useState(false)
  const [value, setValue] = useState(storedValue ? storedValue : input.defaultValue)

  useEffect(() => {
    setValue(storedValue)
  }, [storedValue])

  const onChange = (e) => {
    const currentError = validate(input.params.validation, e.target.value, userInputs)
    setError(currentError)
    saveUserInput(appId, input.name, e.target.value)
    setValue(e.target.value)
  }

  return (
    <>
      <input name={input.name} type={type} required={input.required} onChange={onChange} value={value} />
      {error && <span>{input.errorMessage}</span>}
    </>
  )
}

InputText.propTypes = {
  input: PropTypes.any,
}

export default InputText
